<!-- 汉听报名页 -->
<template>
  <div class="container">
    <van-form ref="form">
      <div class="title">学生信息</div>
      <div class="form">
        <div v-for="(item, index) in studentInfo" :key="item.key" :class="{ 'border': index < studentInfo.length - 1 }">
          <van-field :error="false" v-if="item.type === 'select'" required readonly clickable right-icon="arrow-down"
            name="picker" :value="formData[item.showKey]" :label="item.label" placeholder="请选择"
            @click="handleSelect(item)" :rules="[{ required: true, message: `请选择${item.label}` }]" />
          <van-field :error="false" v-else :type="item.type" rows="1" required clearable v-model="formData[item.key]"
            :label="item.label" placeholder="请输入" :autosize="{ maxHeight: 100, minHeight: 25 }"
            :rules="[{ required: true, message: `请输入${item.label}` }]" :maxlength="item.maxlength" />
        </div>
      </div>
      <div class="title">家长信息</div>
      <div class="form">
        <div v-for="(item, index) in parentInfo" :key="item.key" :class="{ 'border': index < parentInfo.length - 1 }">
          <van-field :error="false" v-if="item.type === 'select'" required readonly clickable right-icon="arrow-down"
            name="picker" :value="formData[item.showKey]" :label="item.label" placeholder="请选择"
            @click="handleSelect(item)" :rules="[{ required: true, message: `请选择${item.label}` }]" />
          <van-field :error="false" v-else :type="item.type" rows="1"
            :required="item.required === undefined ? true : false" clearable v-model="formData[item.key]"
            :label="item.label" placeholder="请输入" :autosize="{ maxHeight: 100, minHeight: 25 }"
            :rules="[{ required: item.required === undefined ? true : false, message: `请输入${item.label}` }, item.type === 'tel' ? { validator, message: '请输入正确的手机号' } : {}]"
            :maxlength="item.maxlength" />
        </div>
      </div>
      <div class="btn-box">
        <div :class="{ 'btn': true, 'disabled': disabled }" @click="submit">
          <van-loading v-if="loading" size="16px" type="spinner" color="#242424" style="margin-right: 7px;" />
          提交
        </div>
      </div>
    </van-form>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columnObjs[selectData.key]" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
  </div>
</template>
<script>
import * as APIS from '@/axios/applyForm/chineseDictation'
export default {
  data() {
    return {
      studentInfo: [
        { label: '学生姓名', key: 'childName', maxlength: 8 },
        { label: '学生性别', key: 'childSexCode', showKey: 'childSexName', type: 'select' },
        { label: '学校', key: 'childSchool', maxlength: 30, type: 'textarea' },
        { label: '年级', key: 'childGradeCode', showKey: 'childGradeName', type: 'select' },
        { label: '班级', key: 'childClass', maxlength: 8 },
      ],
      parentInfo: [
        { label: '家长姓名', key: 'parentName', maxlength: 8 },
        { label: '手机号', key: 'parentPhone', maxlength: 11, type: 'tel' },
        { label: '微信号', key: 'parentWechat', required: false, maxlength: 30 },
      ],
      formData: {},
      columnObjs: {
        childSexCode: [{ text: "男", key: 1 },
        { text: "女", key: 2 }]
      },
      showPicker: false,
      selectData: {},
      loading: false,
    };
  },
  computed: {
    disabled() {
      return this.studentInfo.concat(this.parentInfo).some(v => (v.key !== 'parentWechat') && !this.formData[v.key])
    }
  },
  mounted() {
    APIS.getGradeDict().then(res => {
      this.$set(this.columnObjs, 'childGradeCode', res.data || []);
    })
  },
  methods: {
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return /1[3-9]\d{9}/.test(val);
    },
    handleSelect(item) {
      this.selectData = item;
      this.showPicker = true;
    },
    onConfirm({ key, text }) {
      this.$set(this.formData, this.selectData.key, key);
      this.$set(this.formData, this.selectData.showKey, text);
      this.showPicker = false;
    },
    submit() {
      if (this.loading) return
      this.$refs.form.validate().then(err => {
        if (!err) {
          console.log('校验通过', this.formData);
          this.loading = true;
          APIS.submitForm({ ...this.formData, ...this.$route.query }).then(res => {
            this.loading = false;
            if (res.errcode === 0) {
              this.$router.push({
                path: '/chineseDictationDetail',
              });
              // this.$toast('提交成功');
            } else {
              this.$toast(res.errmsg);
            }
          }).catch(e => {
            this.$toast('网络错误，请稍后再试');
            this.loading = false;
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  background: #F5F5F7;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);

  /* 兼容 iOS >= 11.2 */
  .title {
    font-size: 17px;
    font-weight: 500;
    color: #333333;
    padding: 15px 18px;
    position: relative;
    padding-left: 30px;

    &::before {
      content: "";
      width: 4px;
      height: 16px;
      background: #FFCC01;
      border-radius: 2px;
      position: absolute;
      left: 18px;
      top: 18px;
    }
  }
}

.form {
  background: #fff;
  padding: 0 10px;

  /deep/.van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: 0;
  }

  /deep/.van-cell {
    padding: 18px 16px;

    input {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }

    .van-cell__title {
      span {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
      }
    }

    .van-field__error-message {
      position: absolute;
    }
  }

  .border {
    /deep/.van-cell__value {
      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: #D2D2D2;
        position: absolute;
        bottom: -18px;
        left: 0;
      }
    }
  }
}

.btn-box {
  padding: 0 32px;
  margin-top: 60px;

  .btn {
    width: 100%;
    height: 45px;
    background: #FFCC01;
    border-radius: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #242424;

    &.disabled {
      color: #999999;
      background: #E5E5E5;
    }
  }
}
</style>
